import { useContext, useState } from "react";
import { TextField } from "@mui/material";
import moment from "moment";
import { useMutation } from "@apollo/client";
//Import from project
// import useCheckStudentAttendance from "../../../Hooks/useCheckStudentAttendance";
import { AuthContext } from "../../../Context/AuthContext";
import { CHECK_STUDENT_ATTENDANCE } from "../../../Schema/Class";

export default function ReasonAttendance({
  classId,
  editData,
  setRefetch,
  date,
}) {
  //
  const { t, setAlert } = useContext(AuthContext);
  // const [loading, setLoading] = useState(true);
  const [reason, setReason] = useState(
    editData?.reason ? editData?.reason : ""
  );

  // console.log("editData::", editData?);

  // const { handleSubmit } = useCheckStudentAttendance({
  //   setRefetch,
  //   date: moment(date).format("YYYY-MM-DD"),
  //   status: editData?.status,
  //   classId: classId,
  //   studentId: editData?._id,
  //   reason: "",
  // });

  const [checkStudentAttendance] = useMutation(CHECK_STUDENT_ATTENDANCE, {
    onCompleted: ({ checkStudentAttendance }) => {
      // setReason("");
      setRefetch();
      // setLoading(false);
      if (checkStudentAttendance?.isSuccess) {
        setAlert(true, "success", checkStudentAttendance?.message);
      } else {
        setAlert(true, "error", checkStudentAttendance?.message);
      }
    },
    onError: ({ message }) => {
      // setReason("");
      // setLoading(false);
      console.log("Error::", message);
    },
  });

  const handleSubmit = () => {
    // console.log("reason::", reason);
    checkStudentAttendance({
      variables: {
        classId: classId,
        studentId: editData?._id,
        date: moment(date).format("YYYY-MM-DD"),
        status: editData?.status,
        reason: reason,
      },
    });
  };

  return (
    <TextField
      fullWidth
      size="small"
      multiline
      disabled={editData?.status === "empty"}
      placeholder={t("thead_reason")}
      value={reason ? reason : editData?.reason}
      onChange={(e) => {
        // console.log("target?.value::", e.target.value);
        setReason(e.target.value);
      }}
      onBlur={handleSubmit}
    />
  );
}
